/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Palette, Tokens } from '@jda/lui-common-component-library-mui5';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    flexGrow: 1,
    height: "100%",
  },
  searchBarWrap: {
    width: Tokens.spacing['$sp-80'],
  },
  addButton: {

  },
  loader: {
    backgroundColor: theme.palette.background.paper,
    borderBottomLeftRadius: Tokens.spacing['$sp-1-25'],
    borderBottomRightRadius: Tokens.spacing['$sp-1-25'],
    position: 'absolute',
    height: '100%',
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    padding: Tokens.spacing['$sp-3']
  },
  plusIcon: {
    paddingTop: Tokens.spacing['$sp-1'],
    cursor: 'pointer'
  },
  topLeftHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: Tokens.spacing['$sp-2'],
    textAlign: 'right',
    height: Tokens.spacing['$sp-7-5'],
    color: theme.palette.text.secondary,
    marginRight: Tokens.spacing['$sp-0-25'],
  },
  titleContainer: {
    display: 'flex',
    height: "57px",
    alignItems: 'center',
    padding: Tokens.spacing['$sp-2'],
    fontWeight: 500,
    fontSize: "18px",
  },
  alertMsg: {
    display: 'flex',
    alignItems: 'center',
    margin: Tokens.spacing['$sp-4'],
    padding: Tokens.spacing['$sp-4'],
    borderRadius: Tokens.spacing['$sp-1-25'],
    color: theme.palette.text.primary,
    backgroundColor: Palette.colors.byBlue['50'],
    border: `1px solid ${theme.palette.primary.main}`,
  },
  bellIcon: {
    marginRight: 10,
    color: theme.palette.primary.main,
  },
  mappingList: {
    height: "100%"
  },
  toolbarPanel: {
    padding: Tokens.spacing['$sp-3']
  }
}));

